import { render, staticRenderFns } from "./mup-owner-management-controller.vue?vue&type=template&id=10d812fe&"
import script from "./mup-owner-management-controller.vue?vue&type=script&lang=js&"
export * from "./mup-owner-management-controller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports